<template>
  <div class="tankuang">
    <div class="mask"></div>
    <!--登录弹框-->
    <div class="login-pop" id="login-pop">
      <div class="close-pop close">
        <img src="../../assets/img/close2.png" alt>
      </div>
      <div class="account">
        <p>绑定邮箱</p>
        <div class="form">
          <div class="row">
            <input
              type="text"
              placeholder="请输入邮箱"
              class="phone-num"
              v-model="email"
              v-on:input="getBtn"
            >
            <label>
              <i class="iconfont icon-guanbi-"></i>
            </label>
          </div>
          <div class="row">
            <input
              type="text"
              placeholder="请输入验证码"
              class="code-num"
              v-model="code"
              v-on:input="getBtn"
            >
            <div class="code" v-text="isSend" @click="getCode"></div>
          </div>
        </div>
        <div :class='["look-more",a==0?"active":""]' @click="bindEmail">确定</div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
export default {
  data() {
    return {
      email: "",
      code: "",
      isSend:'发送验证码',
      a: 0
    };
  },
  mounted() {
    const self = this;
    $(".close-pop").click(function() {
      self.$parent.$data.panelModal = false;
    });
  },
  methods: {
    getBtn() {
      if (this.email != "" && this.code != "") {
        this.a = 1;
      } else {
        this.a = 0;
      }
    },
    getCode() {
      this.$http
        .get("/api/user/001-sendEmail", {
          params: {
            email: this.email
          }
        })
        .then(res => {
          console.log(JSON.stringify(res));
          if (res.status == 200 && res.data.code == 0) {
            this.code = res.data.rows[0].code;
            this.timer(60);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    timer(time) {
      alert(999)
      interval = setInterval(() => {
        time--;
        this.isSend = time + "s后重新发送";
        if (time <= 0) {
          clearInterval(interval);
          this.isSend = "60s后重新发送";
        }
      }, 1000);
      return;
    },
    bindEmail() {
      this.$http
        .get("/api/user/014-bindEmail", {
          params: {
            token: this.$store.state.userInfo.token,
            email: this.email,
            code: this.code
          }
        })
        .then(res => {
          if (res.status == 200 && res.data.code == 0) {
            this.$message('验证成功');
            this.$emit('addData');
            setTimeout(() => {
              this.$parent.$data.panelModal = false
            },300)
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.look-more {
  cursor: pointer;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
  pointer-events: none;
  cursor: not-allowed;
}
.form {
  margin-top: 70px;
}
.login-pop {
  top: 40%;
}
.login-pop .account {
  margin-top: 35px;
}
.login-pop .account .form .row {
  height: 50px;
}
.login-pop .account .form .row input,
.login-pop .account .form .row label,
.login-pop .account .form .row .code {
  margin-top: 0px;
}
.login-pop .account .look-more {
  margin-top: 45px;
}
.look-more.active {
  border: none;
  background: #ededed;
  color: #fff;
}
.login-pop .account .form .row label i {
  float: right;
}
</style>